var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.tabbarShow)?_c('tabBar',{attrs:{"datas":_vm.tabbarConfig,"tabbarIndex":_vm.tabbarIndex}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }